import { render, staticRenderFns } from "./AssignmentPerformanceAI.vue?vue&type=template&id=6e93cdec&scoped=true&"
import script from "./AssignmentPerformanceAI.vue?vue&type=script&lang=js&"
export * from "./AssignmentPerformanceAI.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPerformanceAI.vue?vue&type=style&index=0&id=6e93cdec&lang=scss&scoped=true&"
import style1 from "./AssignmentPerformanceAI.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e93cdec",
  null
  
)

export default component.exports